angular.module('qkr').factory('outletService', outletService);
function outletService($http, appConfig, $q, utils, $rootScope, corsService, imageService,
                       menuService, $log) {
    const failedRequest = (funcName, reason) => {
        $log.error('Failed to request, function name ' + funcName);
        $log.error(reason);
    };
    return {
        currentOutletId: null,
        currentDepartmentId: null,
        currentMenuId: null,
        currentMenuType: null,
        currentCategoryId: null,
        allCurrencies: [],
        productList: [],
        editingMenu: null,
        selectedMenu: null,
        getChildOutletFromParentOutlet: (outlets, parentOutletId) => {
            const onlyOutletFromParent = outlet => {
                return outlet.parent &&
                    parseInt(outlet.parent.id, 10) === parseInt(parentOutletId, 10);
            };
            return outlets.filter(onlyOutletFromParent);
        },
        listOutlets: () => $http.get(appConfig.apiUrl + 'outlet/list', {withCredentials: true})
            .then((response) => response.data),

        listOutletsSummary: () => $http.get(appConfig.apiUrl + 'outlet/listOutletsSummary', {withCredentials: true})
            .then((response) => response.data),

        listPaginatedOutlets(form) {
            const deferred = $q.defer();

            $http.post(appConfig.apiUrl + 'outlet/getOutletList', angular.copy(form)).then(
                (response) => {
                    deferred.resolve(response.data);
                },
                (reason) => {
                    deferred.reject(reason.data);
                }
            );
            return deferred.promise;
        },

        /**
         * @deprecated DO NOT USE THIS FUNCTION, use loadOutletDepartments instead !!!
         **/
        loadCurrentOutletDepartments() {
            if(this.outletInfo) {
                return this.loadOutletDepartments(this.outletInfo.id);
            }

            return this.loadOutletDepartments();
        },

        loadOutletDepartments(outletId) {
            return outletId ? $http
                .get(appConfig.apiUrl + 'outlet/' + outletId + '/departments', { withCredentials: true})
                .then(response => response.data) : Promise.reject('No outletId provided');
        },

        loadMenus(outletId, departmentId) {
            return $http.get(appConfig.apiUrl + 'department/' + departmentId + '/menus/', {withCredentials: true})
                .then((response) => response.data);
        },

        loadProductCategoriesForMenu(outletId, departmentId, menuId) {
            return $http.get(appConfig.apiUrl + 'productGroup/' + menuId + '/categories/', {withCredentials: true})
                .then((response) => response.data);
        },

        updateMenu(form) {
            const availability = form.availability;
            const productCategoryIds = [];
            angular.forEach(form.productCategoryIds, (value) => {
                productCategoryIds.push({id: value});
            });

            // Strip out stuff we don't need to send to server (currently causes a problem on server but even when that
            // Is fixed we don't need to send merchant or products when updating menu)
            const updatedMenu = utils.withoutProperties(form, ['merchant', 'products']);

            const updateCommand = {availability, productCategories: productCategoryIds, prodGroup: updatedMenu};
            return $http.post(appConfig.apiUrl + 'productGroup/updateCommand', updateCommand);
        },

        createMenu(form) {
            const newMenu = angular.copy(form);
            const availability = newMenu.availability;

            newMenu.displayOpts = null;
            newMenu.availability = null;
            const productCategoryIds = [];
            angular.forEach(newMenu.productCategoryIds, (value) => {
                productCategoryIds.push({id: value});
            });
            const createCommand = {availability, productCategories: productCategoryIds, prodGroup: newMenu};
            return $http.post(appConfig.apiUrl + 'productGroup/createCommand', createCommand);
        },

        addMenuToDepartment(prodGroup, departmentId) {
            const dep = {id: departmentId};

            const createCommand = {

                prodGroup: utils.idOnly(prodGroup),
                department: utils.idOnly(dep)
            };
            return $http.post(appConfig.apiUrl + 'department/addMenu', createCommand);
        },

        updateAppearance(form) {
            const upload = angular.copy(form);
            if (upload.coverImageUrl) {
                upload.coverImageUrl = imageService.stripQueryString(upload.coverImageUrl);
            }

            if (upload.logoUrl) {
                upload.logoUrl = imageService.stripQueryString(upload.logoUrl);
            }
            return $http.post(appConfig.apiUrl + 'outlet/updateAppearance', upload);
        },

        outletInfo: null,

        createOutlet(outlet) {
            const deferred = $q.defer();
            $http.post(appConfig.apiUrl + 'outlet/create', outlet).then(
                (response) => {
                    deferred.resolve(response);
                }, (reason) => {
                    deferred.reject(reason);
                }
            );
            return deferred.promise;
        },

        setName(commandOutlet) {
            const deferred = $q.defer();
            $http.post(appConfig.apiUrl + 'outlet/setName', commandOutlet).then(
                (response) => {
                    deferred.resolve(response);
                }, (reason) => {
                    deferred.reject(reason);
                }
            );
            return deferred.promise;
        },

        setStatus(commandOutlet) {
            const deferred = $q.defer();

            $http.post(appConfig.apiUrl + 'outlet/setStatus', commandOutlet).then(
                (response) => {
                    deferred.resolve(response);
                }, (reason) => {
                    deferred.reject(reason);
                }
            );

            return deferred.promise;
        },

        saveContactDetails(form) {
            return $http.post(appConfig.apiUrl + 'outlet/updateContact', form);
        },

        updateIntegrationSettings(form) {
            return $http.post(appConfig.apiUrl + 'outlet/updateIntegrationSettings', form);
        },

        loadOnboardingInfo() {
            return $http.get(appConfig.apiUrl + 'outlet/getOnBoardingStatus', {withCredentials: true})
                .then((response) => response.data);
        },

        loadDashboardInfo(outletId) {
            // Do not cache this
            return $http.get(appConfig.apiUrl + 'outlet/getDashboardData', {withCredentials: true})
                .then((response) => response.data);
        },

        loadOutlet(id) {
            if (utils.hasNoValue(this.outletInfo)) {
                return this.refreshOutletInfo(id);
            } else {
                const deferred = $q.defer();
                deferred.resolve(this.outletInfo);
                return deferred.promise;
            }
        },

        refreshOutletInfo(id) {
            let url = appConfig.apiUrl + 'outlet/get';
            if (id != null) {
                url = url + '/' + id;
            }

            const self = this;     // "this" inside the callback doesn't reference the same scope

            return $http.get(url, {withCredentials: true}).then((response) => {
                self.outletInfo = response.data;
                $rootScope.outletInfo = self.outletInfo;
                return self.outletInfo;
            });
        },

        getTimeZoneIdGoogle(lat, log) {
            const outletTimeZoneCommand = {};
            outletTimeZoneCommand.lat = lat;
            outletTimeZoneCommand.lon = log;
            outletTimeZoneCommand.timeStamp = new Date().getTime() / 1000;

            return $http.post(appConfig.apiUrl + 'outlet/getTimeZoneIdGoogle', outletTimeZoneCommand)
                .then((response) => {
                    return response;
                }).catch(reason => $q.reject(reason));
        },

        getDefaultOpeningHours: () => $http.get(appConfig.apiUrl + 'outlet/getDefaultOpeningHours',
            {withCredentials: true}).then((response) => response.data),

        // after outlet creation if is pay at table pos need to call this function
        // just tidy up the function
        linkShareMenuForPos(outletId) {
            const loadedDept = (parentResponse) => {
                return menuService.loadSharedMenus()
                    .then(response => {
                        if(!response[0]) {
                            $log.log('addMenuToDepartment no required');
                            return;
                        }
                        const departmentId = parentResponse[0].id;
                        return this.addMenuToDepartment(response[0], departmentId);
                    }).catch(reason => $q.reject(reason));
            };
            this.loadOutletDepartments(outletId)
                .then(response => loadedDept(response))
                .catch((reason) => failedRequest('loadOutletDepartments', reason));
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/outlet.services.js